<div class="view-info-block">
  <div
    *ngIf="!!title"
    class="view-info-block__header"
    [class.view-info-block__bg_new]="product?.isNew"
    [class.view-info-block__bg_archive]="product?.status === 'archive'"
    [class.view-info-block__bg_review]="product?.status === 'review'"
  >
    <div class="header-title">{{ title }}</div>
  </div>

  <div class="view-info-block__content">
    <div class="text_heading-4 content-title">{{ product?.name }}</div>

    <div class="info">
      <div *ngIf="product?.description" class="info__description">
        <tui-scrollbar class="text-wrapper">
          <app-parse-links
            class="text"
            [value]="product?.description ?? null"
            [disableRedirectDialog]="true"
            (externalLink)="externalLink.emit($event)"
          ></app-parse-links>
        </tui-scrollbar>
      </div>
    </div>

    <div class="buttons">
      <button
        *ngIf="!!product?.terms?.length"
        tuiButton
        type="button"
        [size]="isMobile ? 'm' : 'l'"
        (click)="getDiscount.emit($event)"
      >
        {{ 'components.loyaltyViewInfoBlock.buttons.getDiscount' | translate }}
      </button>

      <lp-favorite-button appearance="block" [product]="product" [size]="isMobile ? 'm' : 'l'"></lp-favorite-button>

      <lp-export-codes-button
        *ngIf="allowedProductCodesExport"
        [size]="isMobile ? 'm' : 'l'"
        [productGroupId]="product?.terms?.[0]?.id"
        [unionId]="productUnionId"
      ></lp-export-codes-button>
    </div>
  </div>
</div>
